import { HandleNegativeOnHand } from "@redotech/cockroachdb-codegen/tables/inventory/handle-negative-on-hand";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateImsSettings = {
  name: "updateImsSettings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    handleNegativeOnHand: z.enum(HandleNegativeOnHand).nullable(),
  }),
  output: z.object({}),
};
